import './style.scss';
import Caption from './caption.js';

export default Caption;